import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { segmentKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useImportSegment = () => {
    const additional = useQueryRequestParams();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (body) => axios.post(markUrl('segments/import/'), body, additional),
        onSuccess: (response, request) => {
            if (request.segment_id) {
                queryClient.setQueryData(segmentKeys.detail(request.segment_id), (current) => current
                    ? {
                        ...current,
                        data: {
                            ...current.data,
                            match_count: response.data.matched
                        }
                    }
                    : current);
            }
            return queryClient.invalidateQueries({ queryKey: segmentKeys.all });
        }
    });
};
export default useImportSegment;
